import React from "react";
import { price, round2 } from "../../../utils";
import { getPricesSteps } from "../../../utils_price";
import { useAuth } from "../../Auth/useAuth";
import useTranslations from "../../Translations/useTranslations";
import { useCart } from "../useCart";
import "./CurrentCartItems.css";
import ItemController from "./ItemController";

function PlvItems({ isQuickDispatchItem = false, disableControls = false }) {
  const CART_KEY_PLV = "PLV";
  const [{ user }] = useAuth();
  const [{ current_cart }, cartSDK] = useCart(user.client_profile?.id);
  const trl = useTranslations();
  if (!current_cart) return null;
  const PLVInCarts = current_cart.products[CART_KEY_PLV] || [];

  const listPLVInCart = isQuickDispatchItem
    ? PLVInCarts.filter((plv) => {
        // Filter for quick dispatch items todo
        return true;
      })
    : PLVInCarts;

  if (listPLVInCart.length === 0) return null;

  const _addPLVInCart = (_article, qte_commande) => {
    const products = current_cart.products;
    const PLV_CART = products[CART_KEY_PLV];
    const creator = user.client_profile?.id;
    const custom_remise = 0;

    const article = { ..._article, generique: {} };

    if (PLV_CART === undefined) {
      // First PLV_ARTICLE
      cartSDK.addInCart({
        creator,
        product: {
          [CART_KEY_PLV]: [{ article, qte_commande, custom_remise }],
        },
      });
    } else {
      const articleIndex = PLV_CART.findIndex(
        (art) => art.article.CODART === article.CODART,
      );
      if (articleIndex >= 0) {
        if (qte_commande > 0) {
          // Article is already in cart
          PLV_CART[articleIndex] = { article, qte_commande, custom_remise };
          cartSDK.addInCart({
            creator,
            product: {
              [CART_KEY_PLV]: PLV_CART,
            },
          });
        } else {
          PLV_CART.splice(articleIndex, 1);
          cartSDK.addInCart({
            creator,
            product: {
              [CART_KEY_PLV]: PLV_CART,
            },
          });
        }
      } else {
        cartSDK.addInCart({
          creator,
          product: {
            [CART_KEY_PLV]: [
              ...PLV_CART,
              { article, qte_commande, custom_remise },
            ],
          },
        });
      }
    }
  };

  function renderItem(plv) {
    const article = plv.article;
    let qte_commande = 0;
    if (plv.qte_commande) {
      qte_commande = plv.qte_commande;
    }
    const onlyOneBuy = 1;
    const maxBuy = null; //  if you want to limit max buy for a product, set a number here;

    function handleAdd() {
      if (
        article.TESTEUR_ou_PLV.startsWith("TES") &&
        qte_commande === onlyOneBuy
      ) {
        return;
      }
      if (maxBuy && qte_commande >= maxBuy) {
        return;
      }
      _addPLVInCart(article, qte_commande + 1);
    }

    function handleRemove() {
      if (qte_commande - 1 < 0) return;
      _addPLVInCart(article, qte_commande - 1);
    }

    function handleEmty() {
      if (!window.confirm(trl.message("Cart.removeProductOnAction"))) return;
      if (qte_commande === 0) return;
      _addPLVInCart(article, 0);
    }
    const remise =
      plv.custom_remise >= 0
        ? plv.custom_remise
        : plv.article.REMISE_FIXE > 0
          ? plv.article.REMISE_FIXE
          : plv.article.groupe_tarifaire.REMISE_FIXE > 0
            ? plv.article.groupe_tarifaire.REMISE_FIXE
            : null;

    let realPUB = plv.article.PUB - (plv.article.PUB * remise) / 100;
    let totalPrice = realPUB * plv.qte_commande;

    if (plv.article.prices) {
      const { priceStep, nbUnit } = getPricesSteps(
        plv.article,
        plv.qte_commande,
      );
      if (priceStep) {
        realPUB = priceStep.price / nbUnit;
        totalPrice = (priceStep.price * plv.qte_commande) / nbUnit;
      }
    }

    const productLabel = `${trl.data.message(
      "ART",
      "CODART",
      article.CODART,
      "LIBART",
    )}  (${article.CODART})`;

    return (
      <React.Fragment>
        <ItemController
          addAction={handleAdd}
          removeAction={handleRemove}
          emptyAction={handleEmty}
          count={qte_commande}
          itemName={productLabel}
          currentPrice={price(round2(totalPrice))}
          isControllerShow={
            !article.TESTEUR_ou_PLV.startsWith("TES") || disableControls
          }
          disableControls={disableControls}
        />
      </React.Fragment>
    );
  }

  const headerStyle = {
    fontFamily: "Quicksand, sans-serif",
    fontSize: "15px",
    fontWeight: "700",
    color: "#000",
    margin: "0.5rem 1rem 0.5rem 1.2rem",
  };

  return (
    <React.Fragment>
      <div style={headerStyle}> {CART_KEY_PLV} </div>
      {listPLVInCart?.map((plv) => (
        <React.Fragment key={plv.article.CODART}>
          {renderItem(plv)}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

export default PlvItems;
